import * as React from 'react';
import { LineDivider } from '@doltech/ui/lib/figma/Divider/LineDivider';
import { AnswerKeyItem, AnswerKeyModel } from './AnswerKeyItem';

interface AnswerKeysTrackProps {
  data: AnswerKeyModel[];
  isPdfContent?: boolean;
}

export const AnswerKeysTrack = (props: AnswerKeysTrackProps) => {
  const { data, isPdfContent } = props;

  return (
    <div>
      {(data || []).map((answerKey, index, arr) => {
        const isFirst = index === 0;
        const isLast = index === arr.length - 1;

        return (
          <React.Fragment key={answerKey.no}>
            <AnswerKeyItem
              data={answerKey}
              isPdfContent={isPdfContent}
              isShowExplanation={isFirst}
            />

            {!isLast && <LineDivider space={16} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};
